module.exports = __webpack_public_path__ + "img/calendar.fa927cf7.svg";